<template>
  <div class="p-8 bg-white rounded-md shadow-md w-96" style="margin-bottom:25vh;">
    <div class="flex justify-center p-5">
      <img src="/logo.png" class="w-56" alt />
    </div>
    <div v-if="isLoading" class="flex justify-center align-center p-20">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <template v-if="!isError && !isLoading && passwordRecovery && !isSuccess">
      <div class="mb-5 text-center">
        <h3 class="text-blue-700">{{ $t('account.change_password') }}</h3>
        <p
          class="text-blue-700 bg-blue-100 p-3 border-blue-500"
        >{{ $t('validate.please_input_new_password') }}</p>
      </div>
      <v-form @submit.prevent="resetPassword" ref="formreset">
        <v-text-field
          type="password"
          :placeholder="$t('account.new_password')"
          :label="$t('account.new_password')"
          background-color="grey lighten-4"
          flat
          id="signup_password"
          solo
          v-model="password"
          autocomplete="on"
          :rules="[rules.password]"
        ></v-text-field>
        <v-text-field
          type="password"
          :placeholder="$t('account.confirm_new_password')"
          :label="$t('account.confirm_new_password')"
          background-color="grey lighten-4"
          flat
          id="confirmPassword"
          solo
          v-model="confirmPassword"
          autocomplete="on"
          :rules="[rules.confirmPassword]"
        ></v-text-field>
        <v-btn width="100%" class="mb-6 btn-reset" color="info" large type="submit" :disabled="isLoading">{{ $t('account.reset_password') }}</v-btn>
      </v-form>
    </template>
    <div v-else-if="!isLoading && isError" class="text-center py-10 pb-12 text-gray-400">
      <h2 class="text-gray-400">{{errorMsg}}</h2>
      <div class="p-2 box-login">
        <v-btn text to="/" class="link-login">
          {{ $t('account.back_to_main_page', {count: countDown}) }}
        </v-btn>
      </div>
    </div>

    <div v-if="!isLoading && isSuccess" class="text-center py-10 pb-12 text-gray-400">
      <h2 class="text-green-400">{{ $t('account.change_password_success') }}</h2>
      <div class="p-2 box-login">
        <v-btn text to="/auth/login" class="link-login">
          {{ $t('account.back_to_login_page', {count: countDown}) }}
        </v-btn>
      </div>
    </div>

    <div class="box-login">
      {{ $t('account.have_account') }}
      <v-btn text to="/auth/login" class="link-login">{{ $t('account.login') }}</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "Forgot-password",
  async created() {
    if (
      this.$route &&
      this.$route.params &&
      this.$route.params.userId &&
      this.$route.params.recoveryId
    ) {
      try {
        this.isLoading = true;
        this.passwordRecovery = await this.$store.dispatch(
          "passwordRecovery/getPasswordRecovery",
          {
            userId: this.$route.params.userId,
            passwordRecoveryId: this.$route.params.recoveryId
          }
        );
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error?.response?.data?.error) {
          this.errorMsg = error.response.data.error;
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else {
          this.errorMsg = error.message;
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        }
      }
      if (this.passwordRecovery && this.passwordRecovery.objectId) {
      } else {
        this.isError = true;
        this.errorMsg = this.errorMsg ? this.errorMsg : "Data not found";
        if (this.delay > 0) {
          this.countDown = this.delay;
          this.isStartCountDown = true;
        } else this.countDown = 0;
        this.countDownTimer();
      }
    } else
      this.$router.push({
        name: "NotFound"
      });
  },
  data() {
    return {
      rules: {
        required: v =>
          (v && v.length == 10) || this.$t('validate.please_input_phone_number'),
        password: p => (p && p.length >= 8) || this.$t('validate.please_input_password'),
        confirmPassword: p => (p && p === this.password) || this.$t('account.password_not_match')
      },
      passwordRecovery: null,
      tel: "",
      password: "",
      confirmPassword: "",
      isError: false,
      errorMsg: "",
      isLoading: false,
      isStartCountDown: false,
      delay: 10,
      countDown: 0,
      isSuccess: false,
      isMount: true
    };
  },
  props: {},
  mounted() {
    localStorage.removeItem("sessionToken");
  },
  beforeDestroy() {
    this.isMount = false;
  },
  methods: {
    async resetPassword() {
      if (this.$refs.formreset.validate()) {
        // await this.checkUsername();
        let newPass;
        try {
          this.isLoading = true;
          newPass = await this.$store.dispatch(
            "passwordRecovery/changePasswordRecovery",
            {
              password: this.password,
              passwordRecoveryId: this.passwordRecovery.objectId,
              userId: this.passwordRecovery.user.objectId
            }
          );
          this.isLoading = false;
          if (newPass.success) {
            this.$toast.show({
              content: this.$t('account.change_password_success'),
              color: "success"
            });
            this.isSuccess = true;
            if (this.delay > 0) {
              this.countDown = this.delay;
              this.isStartCountDown = true;
            } else this.countDown = 0;
            this.countDownTimer();
          } else {
            this.isError = true;
            this.errorMsg = "Error cannot change password.";
            if (this.delay > 0) {
              this.countDown = this.delay;
              this.isStartCountDown = true;
            } else this.countDown = 0;
            this.countDownTimer();
          }
        } catch (error) {
          this.isLoading = false;
          this.isError = true;
          if (error?.response?.data?.error) {
            this.errorMsg = error.response.data.error;
            this.$toast.show({
              content: error.response.data.error,
              color: "error"
            });
          } else {
            this.errorMsg = error.message;
            this.$toast.show({
              content: error.message,
              color: "error"
            });
          }
          if (this.delay > 0) {
            this.countDown = this.delay;
            this.isStartCountDown = true;
          } else this.countDown = 0;
          this.countDownTimer();
        }
      }
    },
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
      if (this.countDown == 0 && this.isStartCountDown && !this.isSuccess) {
        if (this.isMount)
          this.$router.push({
            name: "Login"
          });
      } else if (
        this.countDown == 0 &&
        this.isStartCountDown &&
        this.isSuccess
      ) {
        if (this.isMount)
          this.$router.push({
            name: "Login"
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-reset {
  text-transform: unset;
}

.box-login {
  font-size: 14px;
  text-align: center;
  .link-login {
    padding: 0 !important;
    height: unset !important;
    min-width: unset !important;
    font-size: 14px !important;
    color: var(--v-info-darken2) !important;
    margin: 0;
    text-transform: unset;
    letter-spacing: unset;
  }
  .link-login:hover {
    text-decoration: underline;
  }
  .link-login:hover::before {
    opacity: 0 !important;
  }
}
</style>
